
import React from 'react';

// Helper component for a single result item
const ResultCard = ({ title, value, unit, color, isLarge = false }) => (
    <div className={`p-4 rounded-lg shadow-md ${color}`}>
        <p className="text-sm text-white/80">{title}</p>
        <p className={`font-bold text-white ${isLarge ? 'text-3xl' : 'text-2xl'}`}>
            {value} <span className="text-base font-normal">{unit}</span>
        </p>
    </div>
);

const Results = ({ results, prevStep, handleConfirmAndSend, isLoading }) => {
    const { financial, technical, recommendations } = results;

    return (
        <div>
            <h2 className="text-2xl font-semibold text-center text-gray-800 mb-6">Voici les résultats de votre simulation</h2>
            
            {/* Financial Estimation */}
            <div className="mb-8">
                <h3 className="text-xl font-bold text-blue-700 mb-4">Estimation Financière</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <ResultCard title="Coût de la borne" value={financial.chargerCost} unit="€" color="bg-blue-500" />
                    <ResultCard title="Coût installation" value={financial.installationCost} unit="€" color="bg-blue-500" />
                    <ResultCard title="Aides de l'état" value={`-${(financial.advenirAmount + financial.taxCreditAmount).toFixed(0)}`} unit="€" color="bg-green-500" />
                    <ResultCard title="Coût Total Net" value={financial.totalNetCost.toFixed(0)} unit="€" color="bg-gray-800" isLarge={true} />
                </div>
                <p className="text-xs text-gray-500 mt-2 text-center">Estimation incluant une TVA à {(financial.vatRate * 100).toFixed(1)}%.</p>
            </div>

            {/* Technical Estimation & Recommendation */}
            <div className="grid md:grid-cols-2 gap-8">
                <div>
                    <h3 className="text-xl font-bold text-green-700 mb-4">Borne Recommandée</h3>
                    <div className="bg-gray-50 rounded-lg p-4 flex items-center">
                        {/* <img src={technical.recommendedCharger.image_url} alt={technical.recommendedCharger.model} className="w-24 h-24 mr-4"/> */}
                        <div>
                            <p className="font-bold text-lg">{technical.recommendedCharger.brand} {technical.recommendedCharger.model}</p>
                            <p className="text-gray-600">Puissance : {technical.recommendedCharger.power_kw} kW</p>
                            <ul className="text-sm text-gray-500 list-disc list-inside mt-2">
                                {recommendations.additionalOptions.map(opt => <li key={opt}>{opt}</li>)}
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-bold text-yellow-700 mb-4">Performances Estimées</h3>
                    <div className="space-y-3">
                        <ResultCard title="Temps de recharge (0-100%)" value={technical.chargeTimeHours} unit="heures" color="bg-yellow-600" />
                        <ResultCard title="Économie vs thermique" value={`~${technical.annualSavings}`} unit="€/an" color="bg-green-600" />
                    </div>
                </div>
            </div>

            <div className="mt-10 text-center bg-gray-100 p-4 rounded-lg">
                <p className="font-semibold">Prêt à passer à l'électrique ?</p>
                <p className="text-sm text-gray-600">Recevez ce devis détaillé par email et soyez contacté par l'un de nos experts.</p>
            </div>

            <div className="mt-8 flex justify-between">
                <button type="button" onClick={prevStep} className="px-8 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-colors">
                    Modifier mes choix
                </button>
                <button 
                    type="button" 
                    onClick={handleConfirmAndSend} 
                    disabled={isLoading}
                    className="px-8 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors disabled:bg-gray-400"
                >
                    {isLoading ? 'Envoi en cours...' : 'Confirmer et recevoir par email'}
                </button>
            </div>
        </div>
    );
};

export default Results;
